//primeReact
import { Dialog } from "primereact/dialog"

//styles
import docSignStyles from "../../../styles/documentSigning/DocSign.templates.module.css"

export default function TemplateInfoDialog({
  showTemplate,
  template,
  stripMetaKey,
  onDone,
}) {
  if (!template) {
    return null
  }

  return (
    <Dialog
      header={"Template details"}
      headerClassName={docSignStyles.infoHeader}
      visible={showTemplate}
      onHide={() => {
        onDone()
      }}
      style={{ width: "535px" }}
    >
      <div>
        <div className={docSignStyles.infoTitle}>Title: </div>
        <div className={docSignStyles.infoDetail}>{template.title}</div>
      </div>
      <div>
        <div
          className={`${docSignStyles.infoTitle} ${docSignStyles.infoTitleGap}`}
        >
          Created:
        </div>
        <div className={docSignStyles.infoDetail}>
          {"By: "}
          {stripMetaKey(template?.metadata?.CreatedBy)?.split("|")[0] ||
            "Unknown creator"}
          <br />
          {"At: "}
          {new Date(
            stripMetaKey(template?.metadata?.CreatedAt)
          ).toLocaleString()}
        </div>
      </div>

      <div>
        <div
          className={`${docSignStyles.infoTitle} ${docSignStyles.infoTitleGap}`}
        >
          Documents:
        </div>
        <div className={docSignStyles.infoDetail}>
          <ul>
            {template?.documents?.map((doc, index) => (
              <li key={index}>
                <span style={{ fontWeight: "800" }}>{"- "}</span>
                {doc.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>
        <div
          className={`${docSignStyles.infoTitle} ${docSignStyles.infoTitleGap}`}
        >
          Signer Roles:
        </div>
        <div className={docSignStyles.infoDetail}>
          <ul>
            {template?.signerRoles?.map((sr, index) => (
              <li key={index}>
                <span style={{ fontWeight: "800" }}>{"- "}</span>
                {sr.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Dialog>
  )
}
